import { render, staticRenderFns } from "./nice-button.vue?vue&type=template&id=0b29b2b1&scoped=true"
import script from "./nice-button.vue?vue&type=script&lang=js"
export * from "./nice-button.vue?vue&type=script&lang=js"
import style0 from "./nice-button.vue?vue&type=style&index=0&id=0b29b2b1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29b2b1",
  null
  
)

export default component.exports